exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-search-box-placeholder{position:absolute;width:100%;z-index:-1;overflow:hidden;white-space:nowrap;line-height:30px;color:#6a6a6a}", ""]);
